<template>
	<div class="page pt-0">
		<top-header></top-header>
        <b-container fluid class="mt-2 heading">
			<b-row>
                <b-col cols="4" md="2" sm="3" xs="4">
                    <b-img src="/logo1.png" fluid class="mb-2 float-left"/>
                </b-col>
                <b-col cols="4" md="8" sm="6" xs="4">
                    <h2 class="text-center pt-md-5 font-bold">CENTRAL POLLUTION CONTROL BOARD</h2>
                    <h5><i>PARIVESH BHAWAN EAST ARJUN NAGAR SHAHDARA</i></h5>
                </b-col>
                <b-col cols="4" md="2" sm="3" xs="4">
                    <b-img src="/logo2.png" fluid class="mb-2 float-right"/>
                </b-col>
            </b-row>
		</b-container>
		<b-container class="max-height">
            <b-row>
              <b-col cols="12" xs="12" md="6">
                <img src="/backimage.png" fluid class="w-100"/>
              </b-col>
              <b-col cols="12" sm="12" md="6">
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-badge pill class="px-2" variant="success" v-if="device.OUTPUT_STATUS == '1'">FANS ON</b-badge>
                                <b-badge pill class="mx-2 px-3" variant="danger" v-if="device.OUTPUT_STATUS == '0'">FANS OFF</b-badge>
                                <b-badge pill class="mx-2 px-3" variant="success" v-if="device.SL_VOLTAGE == 120"><i class="bi bi-sun"></i>POWER ON</b-badge>
                                <b-badge pill class="mx-2 px-3" variant="danger" v-if="device.SL_VOLTAGE != 120">POWER OFF</b-badge>
                                <b-badge pill class="mx-2 px-3" variant="primary">{{device.DATA_STAMP}}</b-badge>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container class="buttonbox">
                        <b-row>
                            <b-col>
                                <b-button pill variant="success" class="btn-start" @click="startfunc()">Start</b-button>
                                <b-button pill variant="danger" class="btn-start" @click="stopfunc()">Stop</b-button>
                            </b-col>
                        </b-row>
                    </b-container>
              </b-col>
            </b-row>
        </b-container>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Login',
	components: {
		"top-header": Header,
	},
	beforeCreate: function() {
        document.body.className = 'page';
    },
	mounted(){
		//this.initload();

	},
    sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
            this.reloaddata();
        },
		liverecord(data){
			console.log('-- data is coming --');
			console.log(JSON.stringify(data));

            this.device = data['869622057946403'];

		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		}
    },
	data() {
		var self = this;
		return{
			email: '',
			password: '',
            device: {},
			url: self.$session.get('apiurl')+'api/dashboard'
		};
	},
	methods: {
        reloaddata(){
            if(this.is_connected){
                this.$socket.emit('getdata', '');
            }
            setTimeout(this.reloaddata, 5000);
        },
        startfunc(){
            this.$socket.emit('setcommand', 'START');
        },
        stopfunc(){
            this.$socket.emit('setcommand', 'STOP');
        }
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
.info-box2{
	display: block;
	min-height: 90px;
	background-color: #FFF;
	width: 100%;
	box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	border-radius: 2px;
    margin-bottom: 15px;
}

</style>